import React, { useState, useEffect } from "react";
import axios from "axios"; // Import Axios
import { Container} from "react-bootstrap";
import RecommendationClothing from "./RecommendClothing.js";
import RecommendationGaming from "./RecommendGaming.js";
import RecommendationWatches from "./RecommendWatches.js";
import RecommendationBooks from "./RecommendBooks.js";
const API_URL = process.env.REACT_APP_API_URL_EC2;

const ProductGrid = () => {
  const [products, setProducts] = useState([]);
  const [id, setid] = useState();
  const [cat1, setcat1] = useState();
  const [cat2, setcat2] = useState();
  const category = "watches"; // Set category dynamically if needed

  // useEffect(() => {
  //   // Fetch products using Axios from your backend API
  //   const fetchProducts = async () => {
  //     try {
  //       let response = await axios.post(`${API_URL}/api/getImages`, {
  //         category: category,
  //       });

  //       console.log(response);

  //       setProducts(response.data.data);
  //     } catch (error) {
  //       console.error("Error fetching products:", error);
  //     }
  //   };

  //   fetchProducts();
  // }, []);

  useEffect(() => {
    const storedUserdata = sessionStorage.getItem("user");
    if (storedUserdata) {
      const data = JSON.parse(storedUserdata);
      if (data.id) {
        setid(data.id);
      } else {
        console.error("ID is not available in stored user data.");
      }
    }
  }, []); // Empty dependency array to run only on mount

const handleFetchCategory = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/getcategoryPreference/${id}`);
        console.log(response.data.data.data.categorypreference1)
        if (response.data) {
          if(response.data.data.data.categorypreference1){

            setcat1(response.data.data.data.categorypreference1)
            setcat2(response.data.data.data.categorypreference2)
          }
        }
        
    } catch (error) {
        console.error('Error fetching the images:', error);
       
    }
};


useEffect(() => {
  // Call getUserData when mrn is set
  if (id) {
    handleFetchCategory();
  }
}, [id]); // Depend on mrn so it runs whenever mrn changes

  // Function to render the correct component
  const renderCategoryComponent = (category) => {
    switch (category) {
      case "clothing":
        return <RecommendationClothing />;
      case "gaming":
        return <RecommendationGaming />;
      case "watches":
        return <RecommendationWatches />;
      case "books":
        return <RecommendationBooks />;
      default:
        return null; // Return nothing if category doesn't match
    }
  };

  return (
    <Container className="py-4">
      {renderCategoryComponent(cat1)}
      {renderCategoryComponent(cat2)}
    </Container>
  );
};

export default ProductGrid;
